export const memberPodsSelector = state => ({
  contributionMemberPods: state.memberPods.contributionMemberPods,
  data: state.memberPods.data,
  error: state.memberPods.error,
  isFetching: state.memberPods.isFetching,
  newPodName: state.memberPods.newPodName,
});
